<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { projectownerService } from "../../../services/projectservice/projectowner.service";
import { stockownerService } from "../../../services/financeservice/stockowner.service";
import { stockjournalService } from "../../../services/financeservice/stockjournal.service";
import { servicehelpers } from "../../../services/servicehelpers";
import List from "../../../components/list";
import ShareRow from "../../../components/share-row";
// import ShareModalRow from "../../../components/share-modal-row";
import Select from "@/components/c-select";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
import i18n from "../../../i18n";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  page: {
    title: "Customers List",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    ShareRow,
    // ShareModalRow,
    Select,
    Button,
    Input,
    List 
  },
  data() {
    return {
      fetchingStats: false,
      title: "Customers List",
      isNew: true,
      stockJournalDataList: {},
      stockOwnerSummaryDataList: [],
      projectDataList: {},
      valueProject: 0,

      stockOwnerDataList: {},
      valueStockOwner: 0,
      valueStockOwnerName: '',

      valueShare: [],
      valueShareAmount: [],


    };
  },
  mounted() {
    
    

    this.loadingProjectData();
    this.loadingProjectOwnerData();
    

    this.valueProject = 1;
    this.loadingData();
  },

  methods: {
    loadingData: function(projectId = 1) {

      let param = `?page=0&clause={"clause":[{"conjuction":"and","stock_owner_summaries.project_id":{"value":${projectId}}}]}`;

      this.fetchingStats = false;
      stockownerService.getList(param)
        .then(response => {
          
          this.fetchingStats = true;
          this.stockOwnerSummaryDataList = response.data;

          this.stockOwnerSummaryDataList.map((item) => {
            this.valueShare.push(item.share);
          });

          this.isNew = this.stockOwnerSummaryDataList.length == 0;

          stockjournalService.getList(`?page=0&clause={"clause":[{"conjuction":"and","stock_owner_journals.project_id":{"value":${projectId}}}]}`)
            .then(response => {
              this.stockJournalDataList = response;
          });

        });
    },

    loadingProjectData: function() {
      servicehelpers.getProjectData().then(response => {
        this.projectDataList = response;
      });
    },

    loadingProjectOwnerData: function() {
      projectownerService.getList('?page=0').then(response => {
        this.stockOwnerDataList = response;
      });
    },

    projectChanged: function(event) {
      this.loadingData(event);
    },

    formatCurrency: function(value, sign = '$', decimal = '.00') {
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);
    },

    // removed: function(id) {
    //   stockjournalService.remove(id)
    //     .then(response => {

    //       if(response.status == 200) {
    //         this.$swal.fire({
    //           title: i18n.t('general.confirm.deleted'),
    //           text: i18n.t('general.confirm.success'),
    //           icon: "success",
    //           confirmButtonText: i18n.t('general.ok')
    //         });
    //       }
    //     });
    // },

    deleted: function(id) {

      stockjournalService.remove(id)
        .then(response => {

          if(response.status == 200) {
            this.$swal.fire({
              title: i18n.t('general.confirm.deleted'),
              text: i18n.t('general.confirm.success'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
    },

    pageNavigate: function(param) {
      this.loadingData(param);
    },

    submitAdd: function() {
      this.$router.push(this.$route.query.redirectFrom || {
              name: "customer-add",
          });
    },

    addStockOwner() {

      let ownerName = this.stockOwnerDataList.data.find(item => { return item.id === this.valueStockOwner});

      if(this.stockOwnerSummaryDataList.length > 0) {
        let index = this.stockOwnerSummaryDataList.find(item => { return item.project_owner_id == this.valueStockOwner});
        if(index != null) {return;}
      }

      this.stockOwnerSummaryDataList.push({
        project_id: this.valueProject,
        project_owner_id: this.valueStockOwner,
        share: 0,
        share_amount: 0,
        notation: '',
        name: ownerName ? ownerName.name : ''
      });
    },

    saveSummary() {
      // console.log("Hello");

      let shares = [];
      let total = 0;
      Object.keys(this.$refs).map(el => {
        if(this.$refs[el][0] !== undefined && 'getValue' in this.$refs[el][0]) {
          
          let share = (this.$refs[el][0]).getValue();
          shares.push(share);

          total += parseInt(share.share);
          // console.log(total);

        }
      });

      if(total != 100) {
       
        // Message Alert
        this.$swal.fire({
          title: i18n.t('stock-owner.invalid.title'),
          text: i18n.t('stock-owner.invalid.message'),
          icon: "error",
          confirmButtonText: i18n.t('general.ok')
        });
          
        return;
      }


      //  console.log(JSON.stringify(shares), total);
       stockownerService.insert(shares).then(response => {
          
          if(response.status == 200) {

            //this.stockOwnerSummaryDataList = response.data;

            response.data.map((item) => {

              let index = this.stockOwnerSummaryDataList.findIndex(obj => obj.project_owner_id === item.project_owner_id);
              if(index >= 0) {
                this.stockOwnerSummaryDataList[index].share = item.share;
              }

            });

            this.$swal.fire({
              title: i18n.t('stock-owner.success.title'),
              text: i18n.t('stock-owner.success.message'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            }).then(result => {
              if (result.value) {
                this.isNew = false;
              } 
            });
          }

        });

    },

    confirm: function(id, approve = 0) {
      stockjournalService.confirm({
        id,
        approve
      }).then(response => {

        if(response.status == 200) {
         this.$router.go(this.$router.currentRoute);
        }
      });
    },

    moreClick: function(event, id) {
      if(event == 'approve') {
        this.$swal.fire({
          title: i18n.t('general.cancel-confirm.title'),
          text: i18n.t('stock-owner.more.approve.message'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: i18n.t('general.ok'),
          cancelButtonText: i18n.t('general.cancel')
        }).then(result => {
          if (result.value) {
            this.confirm(id, 1);
          }
        });
      } else if(event == 'reject') {
        this.$swal.fire({
          title: i18n.t('general.cancel-confirm.title'),
          text: i18n.t('stock-owner.more.reject.message'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: i18n.t('general.ok'),
          cancelButtonText: i18n.t('general.cancel')
        }).then(result => {
          if (result.value) {
            this.confirm(id);
          }
        });
      }
    },

    transferClicked: function() {
      console.log('clicked');
      this.$refs['fast-view'].show();
    },

    saveTransfer: function() {

      let total = this.valueShare.reduce((partialSum, a) => partialSum + parseFloat(a), 0);

      if( total == 100) {

        let total_amount = this.stockOwnerSummaryDataList.reduce((partialSum, item) => partialSum + parseFloat(item.share_amount), 0);
        let data = [];

        this.valueShare.map((share, index) => {
          console.log(JSON.stringify(this.stockOwnerSummaryDataList[index]), share);

          let select = this.stockOwnerSummaryDataList[index];
        
          data.push({
            owner_id: select.project_owner_id,
            project_id: select.project_id,
            share: share,
            amount: total_amount * share / total
          })
        });
        
        stockownerService.updateSummary(data).then(response => {

          if(response.status == 200) {
            this.$refs['fast-view'].hide();
            this.$router.go(this.$router.currentRoute);
          }

        });
      }

    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :add="{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'stock-owner-add'}" :title="$t('stock-owner.text')" />
    <div class="row">
      <div class="col-lg-12">

        <b-tabs content-class="p-3 text-muted">
          <b-tab active class="border-0">
            <template v-slot:title>
              <div class="btn-block">
                <i class="bx bx-bookmark bx-tada font-size-20 align-middle me-2"></i>
                {{$t('stock-owner.summary')}}
              </div>
            </template>
            <div class="col-lg-12">
              <div class="row">
                <div class="col-md-3">
                  <Select 
                :text="'name'"
                    @change="projectChanged"
                    :id="'project_id'"
                    :list="this.projectDataList"
                    v-model="valueProject"
                    :label="'property.project'"
                    /> 
                </div>
                <div class="col-md-7" v-show="isNew">
                  <div class="row">
                    <div class="col-md-3">
                      <Select 
                :text="'name'"
                        :id="'project_id'"
                        :list="this.stockOwnerDataList"
                        v-model="valueStockOwner"
                        :label="'stock-owner.owner'"
                        /> 
                    </div>
                    <div class="col-md-3" style="margin-top: 27px;">
                      <Button v-bind:icon="'bx bx-plus-circle bx-tada'" 
                        @click="addStockOwner()"
                        v-bind:buttonType="'button'"
                        v-bind:variant="'success'"
                        v-bind:title="$t('stock-owner.add')"  />
                    </div>
                  </div>
                </div>
                <div class="col-md-2" style="margin-top: 27px;" v-show="!isNew">
                  <Button v-bind:icon="'bx bx-transfer-alt'" 
                    @click="transferClicked()"
                    v-bind:buttonType="'button'"
                    v-bind:variant="'success'"
                    v-bind:title="$t('stock-owner.transfer')"  />
                </div>
                <div class="col-md-2" style="margin-top: 27px;" v-show="isNew">
                  <Button v-bind:icon="'bx bx-save'" 
                        @click="saveSummary()"
                        v-bind:buttonType="'button'"
                        v-bind:variant="'primary'"
                        v-bind:title="$t('stock-owner.save')"  />
                </div>
              </div>
              
              <div class="row" style="padding: 10px; font-size: 16px; ">
                <div class="row" style="margin-bottom: 10px; margin-top: 10px; ">
                  <div class="col-md-6">{{$t('stock-owner.owner')}}</div>
                  <div class="col-md-2" style="text-align: right">{{$t('stock-owner.share')}}</div>
                  <div class="col-md-4" style="text-align: right">{{$t('stock-owner.share-amount')}}</div>
                </div>
                <div class="row" v-for="(item, index) in stockOwnerSummaryDataList" :key="index" 
                    style="margin-bottom: 10px; margin-top: 10px; border-bottom: 1px solid #E7E9EE;">
                    <ShareRow 
                      :ref="`share_${index}`"
                      :isNew="isNew"
                      :item="item" 
                      :index="index" />
    
                </div>
                <div class="row" style="font-size: 22px; margin-bottom: 10px; margin-top: 10px; ">

                  <div class="col-md-8" style="text-align: right">
                    {{$t('stock-owner.total')}}
                  </div>
                  <div class="col-lg-4" style="text-align: right;">
                    <span style="margin-right: 25px;">{{formatCurrency(stockOwnerSummaryDataList.reduce((acc, item) => acc + item.share_amount, 0))}}</span>
                  </div>  
                </div>
              </div>

            </div>
              <!-- v-bind:removes="[removed, {field: 'stock_owner_journal_status_id', value: 1}]" -->

            <b-modal
                :id="'fast-view'"
                :ref="'fast-view'"
                centered
                :title="$t('stock-owner.transfer')"
                title-class="font-22"
                hide-footer
                :hide-header-close="true"
              >
                <div class="row">
                  <div class="row" v-for="(item, index) in stockOwnerSummaryDataList" :key="index" 
                      style="margin-bottom: 10px; margin-top: 10px; ">
                      
                      <!-- <ShareModalRow 
                        :ref="`share_${index}`"
                        :item="item" 
                        :index="index" /> -->

                      <div class="col-md-6" style="font-size: 16pt;">
                        {{item.name}}
                      </div>
                      <div class="col-md-6">
                        <Input 
                          :type="'number'"
                          :id="`share_${index}`"
                          v-model="valueShare[index]"
                          :last="'%'"   />
                      </div> 
  
                  </div>
                  <div class="row">
                    <div class="col-md-3"></div>
                    <div class="col-md-6">
                    <Button v-bind:icon="'bx bx-save'" 
                        @click="saveTransfer()"
                        v-bind:buttonType="'button'"
                        v-bind:variant="'primary'"
                        v-bind:title="$t('stock-owner.transfer')"  />
                    </div>
                    <div class="col-md-3"></div>
                  </div>
                  
                </div>
              </b-modal>


          </b-tab>
          <b-tab>
            <template v-slot:title>
              <div class="btn-block">
                <i class="bx bx-list-ul font-size-20 align-middle me-2"></i>
                {{$t('stock-owner.journal')}}
              </div>
            </template>
            <List v-bind:dataList="stockJournalDataList" 
              v-bind:updating="fetchingStats" 
              v-bind:navigate="pageNavigate"
              v-bind:edit="{link: 'stock-owner-edit'}"
              v-bind:deletes="[deleted, {field: 'stock_owner_journal_status_id', value: 1}]"
              v-bind:formats="[{name: 'status', color: true}, {name: 'invest_amount', type: 'currency', sign: '$'}]"
              v-bind:fields="[ `code: ${$t('stock-owner.code')}`, `name: ${$t('stock-owner.name')}`, 
              `invest_date: ${$t('stock-owner.date')}`, `project: ${$t('property.project')}`, `invest_amount: ${$t('stock-owner.investment')}`,
                `type: ${$t('stock-owner.type')}`, `status: ${$t('stock-owner.status')}`]" 
              v-bind:filter="{
                search: ['stock_owner_journals.notation', 'stock_owner_journals.invest_amount'],
                dropdown: [{
                  title: 'property.project',
                  field: 'stock_owner_journals.project_id',
                  data: this.projectDataList.data,
                  width: 2
                }]
              }"
              v-bind:more="{
                sub: [{
                  name: 'stock-owner.more.print', icon: 'bx bx-printer', link: 'stock-document', column: 'id'
                },{
                  name: 'stock-owner.more.received-payment', icon: 'bx bx-dollar-circle', link: 'stock-owner-received', column: 'id', show: {column: 'stock_owner_journal_status_id', value: 1}
                },{
                  name: 'stock-owner.more.approve.text', icon: 'bx bx-check-circle', link: 'stock-owner-approve', column: 'id', show: {column: 'stock_owner_journal_status_id', value: 1}
                }, {
                  name: 'stock-owner.more.reject.text', icon: 'bx bx-x-circle', action: 'reject', link: 'property-contract', column: 'id', show: {column: 'stock_owner_journal_status_id', value: 1}
                }]
              }"
              @more="moreClick"

            />   
          </b-tab>
        
        </b-tabs>

      </div>
    </div>
       
  </Layout>
</template>